// extracted by mini-css-extract-plugin
export default {"link":"RN-z","disabled":"SN-z"};